var React = require('react');

function Check100 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z M50,2C23.5,2,2,23.5,2,50\r\n\ts21.5,48,48,48s48-21.5,48-48S76.5,2,50,2z M44.2,71L22.3,49.1l1.4-1.4l21.2,21.2l34.4-34.4l1.4,1.4L45.6,71\r\n\tC45.2,71.4,44.6,71.4,44.2,71z"}));
}

Check100.defaultProps = {"width":"100","height":"100"};

module.exports = Check100;

Check100.default = Check100;
